import dashboard from '@/components/dashboard/index.vue';
import compare from '@/components/compare/index.vue';
import deals from '@/components/deals/index.vue';
import auth from '@/components/auth.vue';

export default [
    {
        name: 'dashboard',
        path: '/',
        component: dashboard
    },
    {
        name: 'compare',
        path: '/compare',
        component: compare
    },
    {
        name: 'deals',
        path: '/deals',
        component: deals
    },
    {
        name: 'auth',
        path: '/auth/callback',
        component: auth
    }
];